import { create } from 'zustand';

interface TimingMetricStorage {
  timers: Record<string, number>;
  startTimer: (key: string) => void;
  removeTimer: (key: string) => void;
  getStartTime: (key: string) => number | undefined;
}

export const useTimingMetricStorage = create<TimingMetricStorage>((set, get) => ({
  timers: {},
  startTimer: (key: string) => {
    set((state) => ({
      timers: {
        ...state.timers,
        [key]: performance.now(),
      },
    }));
  },
  removeTimer: (key: string) => {
    set((state) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [key]: _removed, ...rest } = state.timers;
      return { timers: rest };
    });
  },
  getStartTime: (key: string) => {
    return get().timers[key];
  },
}));
